import _defineProperty from "/home/circleci/repo/node_modules/@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es6.object.assign";
import _toConsumableArray from "/home/circleci/repo/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import * as tslib_1 from "tslib";
import classNames from "classnames";
import PropTypes from "prop-types";
import { makePropTypesFactory, makeValidatingTransformFactory } from "./factory";
export var makePropTypes = makePropTypesFactory(function (vars) {
  return {
    backgroundColor: PropTypes.oneOf([].concat(_toConsumableArray(vars.colors), _toConsumableArray(vars.shades))),
    italic: PropTypes.bool,
    textAlign: PropTypes.oneOf(vars.textAlignments),
    textColor: PropTypes.oneOf([].concat(_toConsumableArray(vars.colors), _toConsumableArray(vars.shades))),
    textSize: PropTypes.oneOf(vars.textSizes),
    textTransform: PropTypes.oneOf(vars.textTransforms),
    textWeight: PropTypes.oneOf(vars.textWeights)
  };
});
export var transform = function transform(props) {
  var _classNames;

  var backgroundColor = props.backgroundColor,
      className = props.className,
      italic = props.italic,
      textAlign = props.textAlign,
      textColor = props.textColor,
      textSize = props.textSize,
      textTransform = props.textTransform,
      textWeight = props.textWeight,
      rest = tslib_1.__rest(props, ["backgroundColor", "className", "italic", "textAlign", "textColor", "textSize", "textTransform", "textWeight"]);

  return Object.assign({
    className: classNames((_classNames = {}, _defineProperty(_classNames, "has-background-".concat(backgroundColor), backgroundColor), _defineProperty(_classNames, "has-text-".concat(textColor), textColor), _defineProperty(_classNames, "is-italic", italic), _defineProperty(_classNames, "is-".concat(textTransform), textTransform), _defineProperty(_classNames, "has-text-".concat(textAlign), textAlign), _defineProperty(_classNames, "has-text-weight-".concat(textWeight), textWeight), _defineProperty(_classNames, "is-size-".concat(textSize), textSize), _classNames), className)
  }, rest);
};
export var makeValidatingTransform = makeValidatingTransformFactory(makePropTypes, transform);